import { BUTTON_WIDTH } from "../../constants/constants";

/**
 * Gets the width of the left charms container.
 * @param searchAlignmentWidth - The width of the search alignment container.
 * @returns The width of the left charms container in pixels.
 */
export default function getLeftCharmsContainerWidth(searchAlignmentWidth: number): number {
    // Why is it necessary to subtract 48px?
    // In OWA, there is an app launcher button,
    // and in Monarch, there is an app icon, both measuring 48px.
    return searchAlignmentWidth - BUTTON_WIDTH;
}
